.section {
  padding: 7rem 2rem;
  background: var(--color-background);
  border-top: 1px solid var(--color-border);
}

.container {
  max-width: 74rem;
  margin: 0 auto;
  text-align: start;

  &[data-has-blog] {
    display: grid;
    grid-template-columns: minmax(0, 1.2fr) minmax(0, 1fr);
    gap: 4rem;
    align-items: start;
  }
}

.title {
  margin: 0 0 2rem;
}

.subtitle {
  max-width: 620px;
  margin: 0 auto 3rem;
}

.faqs {
  display: flex;
  flex-direction: column;
  gap: 0;
  border-top: 1px solid var(--color-border);
  text-align: start;
}

.faq {
  overflow: hidden;
  border-bottom: 1px solid var(--color-border);
  border-radius: 0 !important;
  background: transparent;
}

.question {
  width: 100%;
  padding: 1.125rem 0;
  background: transparent;
  border: none;
  text-align: start;
  color: var(--color-foreground);

  &:hover {
    background: var(--color-surface-subtle);
  }

  &:focus-visible {
    outline: 2px solid var(--color-primary);
    outline-offset: -3px;
    border-radius: 0.25rem;
  }
}

.indicator {
  width: 2rem;
  height: 2rem;
  border-radius: 0;
  background: transparent;
  color: var(--color-muted);

  [data-open] & {
    color: var(--color-primary);
  }
}

.answer {
  padding-block: 0 1.25rem;
  padding-inline: 0 2.5rem;
  max-width: 76ch;
  line-height: 1.7;

  p {
    line-height: inherit;
  }
}

@media (max-width: 1000px) {
  .container[data-has-blog] {
    grid-template-columns: minmax(0, 1fr);
    gap: 3rem;
  }
}

@media (max-width: 768px) {
  .section {
    padding: 4rem 1.25rem;
  }

  .question {
    padding: 1rem 0;
  }

  .answer {
    padding-block: 0 1.25rem;
    padding-inline: 0 2rem;
  }
}

@media (prefers-reduced-motion: reduce) {
  .faq {
    transition: none;
  }
}

.questionText {
  font-size: 1.0625rem;
  line-height: 1.5;
}

.answerText,
.answerLink {
  font-size: clamp(1.0625rem, 1rem + 0.2vw, 1.125rem);
  line-height: 1.7;
}

.answerLink {
  margin-top: 0.75rem;
}
